import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Label } from "@progress/kendo-react-labels";
import {  DatePicker } from "@progress/kendo-react-dateinputs";
import { Tile } from "components/UIComponents/Tile";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import { useState } from "react";
import { addOwners } from "api";
import { toast } from "react-toastify";
import { FormInput } from "components/Matters";
import { NumericTextBox } from "@progress/kendo-react-inputs";

const AddOwners = (props) => {
  const ownersData = props.data;
  const [date, setDate] = useState({
    owner1: ownersData?.owner1?.dateOfBirth
      ? new Date(ownersData?.owner1?.dateOfBirth)
      : null,
    owner2: ownersData?.owner2?.dateOfBirth
      ? new Date(ownersData?.owner2?.dateOfBirth)
      : null,
    owner3: ownersData?.owner3?.dateOfBirth
      ? new Date(ownersData?.owner3?.dateOfBirth)
      : null,
    owner4: ownersData?.owner4?.dateOfBirth
      ? new Date(ownersData?.owner4?.dateOfBirth)
      : null,
  });
  const [notes, setNotes] = useState(props.item?.details || "");
  const [inputState, setInputState] = useState({
    percentage_1: ownersData?.owner1?.heldPercentage || 0,
    percentage_2: ownersData?.owner1?.heldPercentage || 0,
    percentage_3: ownersData?.owner1?.heldPercentage || 0,
    percentage_4: ownersData?.owner1?.heldPercentage || 0,
    name_1: ownersData?.owner1?.firstName,
    name_2: ownersData?.owner2?.firstName,
    name_3: ownersData?.owner3?.firstName,
    name_4: ownersData?.owner4?.firstName,
  });
  const [isEdited, setIsEdited] = useState(false);
  const handleInputChange = (value, label) => {
    if (label.includes("percentage")) {
      const remainingPercentages = Object.keys(inputState).filter(
        (name) => name.includes('percentage') && name !== label
      );
      let sum =
        value === null || value === undefined || value === ""
          ? 0
          : parseInt(value, 10) || 0;
      for (let num = 0; num < remainingPercentages.length; num++) {
        sum +=
          parseInt(inputState[remainingPercentages[num]], 10) || 0;
      }
      if (sum > 100) return;
    }
    setInputState({
      ...inputState,
      [label]: value,
    });
  };

  const handleSubmit = async () => {
    try {
      const data = {
        owner1: {
          firstName: inputState["name_1"],
          dateOfBirth: date["owner1"],
          heldPercentage: inputState["percentage_1"],
        },
        owner2: {
          firstName: inputState["name_2"],
          dateOfBirth: date["owner2"],
          heldPercentage: inputState["percentage_2"],
        },
        owner3: {
          firstName: inputState["name_3"],
          dateOfBirth: date["owner3"],
          heldPercentage: inputState["percentage_3"],
        },
        owner4: {
          firstName: inputState["name_4"],
          dateOfBirth: date["owner4"],
          heldPercentage: inputState["percentage_4"],
        },
      };
      await addOwners({ data: data }, props.clientId);
      toast.success("Director Added");
      props.cancelEdit();
      props.onUpdateData();
    } catch (error) {
    }
  };

  return (
    <Dialog
      title={"Edit Beneficial Owner"}
      onClose={props.cancelEdit}
      width={1050}
      className="p-3"
    >
      <div className="p-4">
        <Tile
          heading="Proof Details"
          className="mb-2 ps-4 pe-4 overflow-auto"
          height={500}
        >
          <div className="conatiner-fluid">
            <div className="row mt-2 mb-4">
              <div className="col-3 me-5">
                <FormInput
                  className={"form-date-picker note-date-picker "}
                  wf={true}
                  isStyled={true}
                  width={"260px"}
                  labelForComboBox={"Name"}
                  differentName={true}
                  name={"name_1"}
                  onChangeInput={handleInputChange}
                  state={inputState}
                />
              </div>
              <div className="col-3 me-5 form-date-picker note-date-picker ">
                <Label className="label  mb-1 w-100">Date&nbsp;</Label>
                <DatePicker
                  toggleButton={CalenderCustomToggleButton}
                  placeholder="Select Date"
                  onChange={(e) => {
                    setDate({
                      ...date,
                      owner1: e.value,
                    });
                  }}
                  value={date["owner1"]}
                  className="px-3"
                  style={{
                    height: "32px",
                    width: "260px",
                  }}
                />
              </div>
              <div className="col-3 me-2">
                <Label className="label mb-1 w-100">Percentage Held</Label>
                <NumericTextBox
                  style={{ width: "260px", height: "32px" }}
                  value={inputState["percentage_1"]}
                  onChange={(e) => handleInputChange(e.value, "percentage_1")}
                  spinners={false}
                  format="n2"
                  placeholder="0.00"
                  className="right-align"
                />
              </div>
            </div>
            <hr />
            <div className="row mt-4 mb-4">
              <div className="col-3 me-5">
                <FormInput
                  className={"form-date-picker note-date-picker "}
                  wf={true}
                  isStyled={true}
                  width={"260px"}
                  labelForComboBox={"Name"}
                  differentName={true}
                  name={"name_2"}
                  onChangeInput={handleInputChange}
                  state={inputState}
                />
              </div>
              <div className="col-3 me-5 form-date-picker note-date-picker ">
                <Label className="label  mb-1 w-100">Date&nbsp;</Label>
                <DatePicker
                  toggleButton={CalenderCustomToggleButton}
                  placeholder="Select Date"
                  onChange={(e) => {
                    setDate({
                      ...date,
                      owner2: e.value,
                    });
                  }}
                  value={date["owner2"]}
                  className="px-3"
                  style={{
                    height: "32px",
                    width: "260px",
                  }}
                />
              </div>
              <div className="col-3 me-2">
                <Label className="label mb-1 w-100">Percentage Held</Label>
                <NumericTextBox
                  style={{ width: "260px", height: "32px" }}
                  value={inputState["percentage_2"]}
                  onChange={(e) => handleInputChange(e.value, "percentage_2")}
                  spinners={false}
                  format="n2"
                  placeholder="0.00"
                  className="right-align"
                />
              </div>
            </div>
            <hr />
            <div className="row mt-4 mb-4">
              <div className="col-3 me-5">
                <FormInput
                  className={"form-date-picker note-date-picker "}
                  wf={true}
                  isStyled={true}
                  width={"260px"}
                  labelForComboBox={"Name"}
                  differentName={true}
                  name={"name_3"}
                  onChangeInput={handleInputChange}
                  state={inputState}
                />
              </div>
              <div className="col-3 me-5 form-date-picker note-date-picker ">
                <Label className="label  mb-1 w-100">Date&nbsp;</Label>
                <DatePicker
                  toggleButton={CalenderCustomToggleButton}
                  placeholder="Select Date"
                  onChange={(e) => {
                    setDate({
                      ...date,
                      owner3: e.value,
                    });
                  }}
                  value={date["owner3"]}
                  className="px-3"
                  style={{
                    height: "32px",
                    width: "260px",
                  }}
                />
              </div>
              <div className="col-3 me-2">
                <Label className="label mb-1 w-100">Percentage Held</Label>
                <NumericTextBox
                  style={{ width: "260px", height: "32px" }}
                  value={inputState["percentage_3"]}
                  onChange={(e) => handleInputChange(e.value, "percentage_3")}
                  spinners={false}
                  format="n2"
                  placeholder="0.00"
                  className="right-align"
                />
              </div>
            </div>
            <hr />
            <div className="row mt-4 mb-2">
              <div className="col-3 me-5">
                <FormInput
                  className={"form-date-picker note-date-picker "}
                  wf={true}
                  isStyled={true}
                  width={"260px"}
                  labelForComboBox={"Name"}
                  differentName={true}
                  name={"name_4"}
                  onChangeInput={handleInputChange}
                  state={inputState}
                />
              </div>
              <div className="col-3 me-5 form-date-picker note-date-picker ">
                <Label className="label  mb-1 w-100">Date&nbsp;</Label>
                <DatePicker
                  toggleButton={CalenderCustomToggleButton}
                  placeholder="Select Date"
                  onChange={(e) => {
                    setDate({
                      ...date,
                      owner4: e.value,
                    });
                  }}
                  value={date["owner4"]}
                  className="px-3"
                  style={{
                    height: "32px",
                    width: "260px",
                  }}
                />
              </div>
              <div className="col-3 me-2">
                <Label className="label mb-1 w-100">Percentage Held</Label>
                <NumericTextBox
                  style={{ width: "260px", height: "32px" }}
                  value={inputState["percentage_4"]}
                  onChange={(e) => handleInputChange(e.value, "percentage_4")}
                  spinners={false}
                  format="n2"
                  placeholder="0.00"
                  className="right-align"
                />
              </div>
            </div>
          </div>
        </Tile>
      </div>
      {/* <div className={`${styles["director-tile"]} p-2 m-4 ms-5 me-5`}>
        <div className="p-3 ps-4">
          <div className="form-date-picker note-date-picker mt-2">
            <FormInput
              className={"form-date-picker note-date-picker "}
              wf={true}
              isStyled={true}
              width={"260px"}
              label={"Name"}
              onChangeInput={handleInputChange}
              state={inputState}
            />
          </div>

          <div className="mt-3">
            <FormInput
              className={"form-date-picker note-date-picker "}
              wf={true}
              isStyled={true}
              width={"260px"}
              label={"Last_Name"}
              onChangeInput={handleInputChange}
              state={inputState}
            />
          </div>

          <div className="form-date-picker note-date-picker mt-3">
            <Label className="label mt-1 mb-1 w-100">Date&nbsp;</Label>
            <DatePicker
              toggleButton={CalenderCustomToggleButton}
              onChange={(e) => {
                setDate(e.value);
              }}
              value={date}
              className="px-3"
              style={{
                height: "32px",
                width: "260px",
              }}
            />
          </div>
        </div>
      </div> */}
      <div className="dialog-footer">
        <button
          className="bgBtnSecondary common-btn me-2"
          onClick={() => {
            if (isEdited) {
              setIsEdited(false);
            } else {
              props.cancelEdit();
            }
          }}
        >
          Cancel
        </button>
        <button
          className="common-btn me-3"
          onClick={() => {
            handleSubmit();
          }}
        >
          {"Save"}
        </button>
      </div>
    </Dialog>
  );
};

export default AddOwners;
